export const PAK_FETCH_PERSON_API_KEYS = `PAK_FETCH_PERSON_API_KEYS`;
export const PAK_FETCH_PERSON_API_KEYS_START = `${PAK_FETCH_PERSON_API_KEYS}_START`;
export const PAK_FETCH_PERSON_API_KEYS_SUCCESS = `${PAK_FETCH_PERSON_API_KEYS}_SUCCESS`;
export const PAK_FETCH_PERSON_API_KEYS_FAIL = `${PAK_FETCH_PERSON_API_KEYS}_FAIL`;

export const PAK_SAVE_PERSON_API_KEY = `PAK_SAVE_PERSON_API_KEY`;
export const PAK_SAVE_PERSON_API_KEY_START = `${PAK_SAVE_PERSON_API_KEY}_START`;
export const PAK_SAVE_PERSON_API_KEY_SUCCESS = `${PAK_SAVE_PERSON_API_KEY}_SUCCESS`;
export const PAK_SAVE_PERSON_API_KEY_FAIL = `${PAK_SAVE_PERSON_API_KEY}_FAIL`;

export const PAK_DELETE_PERSON_API_KEY = `PAK_DELETE_PERSON_API_KEY`;
export const PAK_DELETE_PERSON_API_KEY_START = `${PAK_DELETE_PERSON_API_KEY}_START`;
export const PAK_DELETE_PERSON_API_KEY_SUCCESS = `${PAK_DELETE_PERSON_API_KEY}_SUCCESS`;
export const PAK_DELETE_PERSON_API_KEY_FAIL = `${PAK_DELETE_PERSON_API_KEY}_FAIL`;

export const PAK_EDIT_PERSON_API_KEY_DONE = `PAK_EDIT_PERSON_API_KEY_DONE`;
export const PAK_SET_API_KEY_TO_EDIT = `PAK_SET_API_KEY_TO_EDIT`;

// COR-28456: encode personId in case it contains special or accented chars
export const fetchPersonApiKeys = personId => ({
  type: PAK_FETCH_PERSON_API_KEYS,
  meta: {
    xmApi: true,
    customUriWithParamsGenerator: encodedUri => encodedUri,
    uri: `/webapi/xm/1/people/${encodeURIComponent(personId)}/api-keys`,
    method: 'get',
  },
  payload: {
    personId,
  },
});

export const savePersonApiKey = (personId, apiKey) => ({
  type: PAK_SAVE_PERSON_API_KEY,
  meta: {
    xmApi: true,
    isUriEncoded: true,
    uri: `/webapi/xm/1/people/${encodeURIComponent(personId)}/api-keys`,
    method: 'post',
    params: {
      ...apiKey,
    },
  },
  payload: {
    personId,
  },
});

export function deletePersonApiKey(personId, apiKey) {
  return {
    type: PAK_DELETE_PERSON_API_KEY,
    meta: {
      xmApi: true,
      isUriEncoded: true,
      uri: `/webapi/xm/1/people/${encodeURIComponent(
        personId,
      )}/api-keys/${apiKey}`,
      method: 'del',
    },
    payload: {
      personId,
      apiKey,
    },
  };
}

export const editPersonApiKeyDone = personId => ({
  type: PAK_EDIT_PERSON_API_KEY_DONE,
  payload: {
    personId,
  },
});

export const setApiKeyToEdit = (personId, apiKey) => ({
  type: PAK_SET_API_KEY_TO_EDIT,
  payload: {
    personId,
    apiKey,
  },
});
